/**
 * The options a designation dropdown should render for a record that already
 * holds a value.
 *
 * The configured list is what the dropdown OFFERS; it is not the set of values
 * that can legally sit in the column. `users.designation_dept` holds whatever
 * was written when the row was created - a label an admin has since removed
 * from Company Settings, or the system-derived jobRole that back-office
 * onboarding stamps there ('Sales RM', 'Super Admin'), neither of which is on
 * the department list.
 *
 * A native <select> whose value matches no <option> falls back to the FIRST
 * option, so without this the edit form silently displays "Not set" for an
 * employee who does have a department, and saving would then clear it - the
 * same failure mode that destroyed lead-source attribution (see
 * features/sales-rm/addLeadSchema.ts). Appending the stored value as its own
 * option makes the form show the truth and round-trip it untouched.
 *
 * Matched case-insensitively so a differently-cased copy of an existing option
 * is not appended as a second, near-identical entry.
 */
export const optionsWithStored = (
  configured: readonly string[],
  stored: string | null | undefined,
): string[] => {
  const value = stored?.trim();
  if (!value) return [...configured];
  const known = configured.some((option) => option.toLowerCase() === value.toLowerCase());
  return known ? [...configured] : [...configured, value];
};
